import  MarlipinConnection from './marlipin/connection.Marlipin';
// import AbstractCommManager from './AbstractCommManager';

export enum Operator {
	SPEARHEAD = 'SPEARHEAD',
	MARLIPIN = 'MARLIPIN',
}
const PROVIDER = "MARLIPIN";

export function getProviderConnection() : MarlipinConnection {
  switch(PROVIDER) {
    case Operator.MARLIPIN:
       return new MarlipinConnection();
    default: return new MarlipinConnection();
  }
}